"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _ApiProvider = require("./components/ApiProvider");
var _NotificationMenuContent = require("./components/NotificationMenuContent");
var _defaultTranslations = require("./constants/defaultTranslations");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OverlayBox = (0, _mui.styled)(_mui.Box)(() => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',
  zIndex: 800
}));
const useVisibility = () => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);

  // Visibility is managed from outside too (with events)
  (0, _react.useEffect)(() => {
    const toggleMenu = event => {
      if (event.detail.menuType === ToggleMenuFlyout.MenuTypes.Notifications) {
        setIsVisible(prev => !prev);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener(ToggleMenuFlyout.Name, toggleMenu);
    return () => {
      window.removeEventListener(ToggleMenuFlyout.Name, toggleMenu);
    };
  }, []);
  const close = (0, _react.useCallback)(() => setIsVisible(false), []);
  return [isVisible, {
    close
  }];
};
const NotificationsMenu = () => {
  const [isVisible, {
    close
  }] = useVisibility();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "NotificationMenu",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Growth,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_i18n.TranslationsNamespaceProvider, {
            namespace: _defaultTranslations.translationsNamespace,
            children: [isVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OverlayBox, {
              onClick: close
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
              timeout: 300,
              in: isVisible,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationMenuContent.NotificationMenuContent, {
                  isVisible: isVisible
                })
              })
            })]
          })
        })
      })
    })
  });
};
exports.NotificationsMenu = NotificationsMenu;
